import { createProxyClient } from '../api/createProxyClient';

/**
 * Price-API-Client. Immer ueber den BFF-Proxy `/proxy/price/...`. Der BFF
 * injiziert server-seitig das GATEWAY_SHARED_SECRET (price-api hat
 * gateway-guard). Kein Operator-Bearer noetig.
 *
 * Nutzt jetzt die gemeinsame createProxyClient-Fabrik (#116).
 */
const client = createProxyClient('price');

export const priceFetch = client.fetch;
export const isPriceProxyEnabled = client.isEnabled;
